// import external dependencies
import 'jquery';

// Import Isotope
import 'isotope-layout/dist/isotope.pkgd.min';
// Import Slick
import 'slick-carousel/slick/slick.min';
// Import ImagesLoaded
import 'imagesloaded/imagesloaded';
//Import MediaElelemt
import 'mediaelement';
// Import everything from autoload

// Import lightgallery
import 'lightgallery/src/js/lightgallery';
// Import js video
//import 'video.js/dist/video.js'
// Import lgvideo
import 'lg-video/dist/lg-video.js'

// Import everything from autoload


// import local dependencies
import Router from './util/Router';
import common from './routes/common';
import home from './routes/home';
import aboutUs from './routes/about';
import qAndA from './routes/q-and-a';

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // q and a
  qAndA,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



//////////////////
// WEBPACK FOOTER
// ./scripts/main.js
// module id = 3
// module chunks = 0